import React, { Component } from 'react'
import PropTypes            from 'prop-types'
import Transition           from 'react-transition-group/Transition'
import './index.less'

class Popup extends Component {

  static propTypes = {
    show: PropTypes.bool,
    confirmText: PropTypes.string,
    cancelText: PropTypes.string,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
  }

  handleConfirm() {
    this.props.onConfirm()
  }

  handleCancel() {
    this.props.onCancel()
  }

  getStyle(status) {
    switch (status) {
      case 'entered':
        return {
          opacity: 1,
        }
      case 'entering':
      case 'exiting':
      case 'exited':
      default:
        return {
          opacity: 0,
          pointerEvents: 'none',
        }
    }
  }

  render() {
    const {
      show,
      confirmText,
      cancelText,
    } = this.props
    return (
      <Transition in={show} timeout={{ enter: 0, exit: 0 }} mountOnEnter unmountOnExit>
        {status =>
          <div className="popup-mask">
            <div className={`popup ${status}`}>
              <div className="popup-body">
                {this.props.children}
              </div>
              <div className="popup-footer">
                {cancelText && <button onClick={this.handleCancel.bind(this)}>{cancelText}</button>}
                {cancelText && <div className="gap"></div>}
                {confirmText && <button className="primary" onClick={this.handleConfirm.bind(this)}>{confirmText}</button>}
              </div>
            </div>
          </div>
        }
      </Transition>
    )
  }
}

Popup.defaultProps = {
  show: false,
  confirmText: '',
  cancelText: '',
  onConfirm: () => {
  },
  onCancel: () => {
  },
}

export default Popup



// WEBPACK FOOTER //
// ./src/components/Popup/index.js